import { GetDebitCardTransactions_getDebitCardTransactionsV2_transactions_merchant as MerchantData } from 'types/gql-types/GetDebitCardTransactions'

type MerchantBasicDetails = Pick<MerchantData, 'id' | 'name' | 'icon'>

export const padWithNulls = (merchant: MerchantBasicDetails): MerchantData => ({
  __typename: 'MerchantDetails',
  id: merchant.id,
  name: merchant.name,
  icon: merchant.icon,
  address: null,
  hours: null,
  phone: null,
  email: null,
  url: null,
  abn: null,
  location: null,
  locationAccuracy: null,
})
